const makeMailToLink = emailId => "mailto:".concat(emailId);
export const getContactPartnerUrl = props => {
  const {
    securityEmailId,
    partnerId,
    mpacBaseUrl,
    supportEmailId
  } = props;
  const ariaLabel = 'Contact the partner open in new window';
  const ariaLabelForEmail = 'Contact the partner open in Email tool';
  if (securityEmailId) {
    return {
      url: makeMailToLink(securityEmailId),
      ariaLabel: ariaLabelForEmail
    };
  }
  if (supportEmailId) {
    return {
      url: makeMailToLink(supportEmailId),
      ariaLabel: ariaLabelForEmail
    };
  }
  if (partnerId) {
    return {
      url: "".concat(mpacBaseUrl, "/vendors/").concat(partnerId),
      ariaLabel
    };
  }
  return {};
};